<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Add Accountant</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>
		            
	            <v-flex xs12 sm12 md12 form-item>
	               <v-text-field  type="tel" v-model="Form.PhoneNumber" prefix="+91" label="Phone Number" placeholder=" " v-validate="'required|numeric|min:10|max:10'" :error-messages="errors.collect('phoneNumber')" data-vv-name="phoneNumber" data-vv-as="phone number"></v-text-field>
	            </v-flex>

			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>

		</v-form>

	    <!-- <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog> -->

	    <!-- fn_draftAction is in draft mixin -->
	    <!-- <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard> -->

	    <!-- <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar> -->

	</div>
</template>

<script>

// const dialogjs =  require('../dialog').dialogjs;
// const menuItem = require('../../../../config.js').configs.menuItem;

// import dialogDiscard from '../../../dialogs/dialog_discard'
// import {draftMixin} from '../../../draft_mixin'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'


	export default{
		// mixins: [draftMixin],
		data(){
			return{
				Form:{"PhoneNumber":null},
			}
		},
		methods:{

			fn_checkValidations: function(){
				var self = this;
			      this.$validator.validateAll().then((result) => {
			        if (result) {
			        	this.showLoading("Please wait...");
						this.$root.fn_getAuthToken(token=>{
		                   this.fn_post(token);
		                });
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			     });
			},
			
			fn_post: function(token){

				if(!navigator.onLine){
                    this.showToast('Internet not available');
                    return;
                }

                let self = this;

                let postObj = {};
                postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;
                postObj.token = token;
                postObj.PhoneNumber = '91' + this.Form.PhoneNumber;

                this.postServerData('PostAccountant', postObj, {
                    onSuccess: function(response){
                       console.log(response);
                       self.showToast('Accountant added.');
                       self.hideLoading();
                       self.fn_goBack();
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			window.js_globals.fn_onBackPress = this.fn_goBack;

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

		}

	}

</script>


// WEBPACK FOOTER //
// src/components/settings/accountant/form.vue